import { useApi } from '@/api';
import { Page, EntityName, Blockie, PageSkeleton } from '@/components';
import { CryptoIcon, Heading, Flex } from '@blockanalitica/ui';
import TakesTable from './TakesTable';
import KicksTable from './KicksTable';
import { useParams } from 'react-router-dom';
import OverviewKpis from './OverviewKpis';

export default function LiquidationPage() {
  const { ilk, auction_id } = useParams();

  const [data, error] = useApi({
    url: `/liquidations/${ilk}/${auction_id}/overview/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page
        title={
          <Flex
            justifyContent="space-between"
            gap={['m', 's']}
            flexDirection={['column', 'row']}>
            <EntityName
              symbol1={
                <CryptoIcon
                  name={data.symbol}
                  address={data.collateral_address}
                  size="5"
                />
              }
              symbol2={<Blockie address={data.urn} imgSize="5" />}>
              <Heading size="1">
                {data.ilk} Liquidation #{auction_id}
              </Heading>
            </EntityName>
          </Flex>
        }>
        <OverviewKpis data={data} />
        <KicksTable ilk={ilk} auction_id={auction_id} />
        <TakesTable ilk={ilk} auction_id={auction_id} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
